import type { TextStyleCategory, TextStyleSize, TextStyleVariant } from '@sirius/typography';

import { AvatarSize } from '../types/avatar-size.type';

interface AvatarTextStyle {
    category: TextStyleCategory;
    size: TextStyleSize;
    variant?: TextStyleVariant;
}

export abstract class AvatarData {
    public static dimensions: Record<AvatarSize, number> = {
        xs: 24,
        s: 32,
        m: 48,
        l: 64,
        xl: 96,
        xxl: 148,
    };

    public static singleCharacterSizes = new Set<AvatarSize>(['xs', 's']);

    /**
     * Initials typography per avatar size. The small sizes use `system` (the
     * `title` style has no usable xs/s), the rest scale `title`. One map, one
     * source of truth — tweak here and verify in Storybook.
     */
    public static textStyle: Record<AvatarSize, AvatarTextStyle> = {
        xs: { category: 'system', size: 's', variant: 'bold' },
        s: { category: 'system', size: 'm', variant: 'bold' },
        m: { category: 'title', size: 's' },
        l: { category: 'title', size: 'm' },
        xl: { category: 'title', size: 'l' },
        xxl: { category: 'title', size: 'xl' },
    };
}
